import { faTrashAlt } from "@fortawesome/free-regular-svg-icons";
import { faPencilAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Button } from "react-bootstrap";
import { GridColumn, GridContainer, GridHeader, GridHeaders, GridRow } from "./styles";

export type RangeDateType = {
  id: string;
  startDate: string | null;
  endDate: string | null;
  weekDays: string[];
};

type RangeDateGridProps = {
  list?: RangeDateType[];
  headers?: string[];
  editable?: boolean;
  deletable?: boolean;
  onEdit?: (id: string) => void;
  onDelete?: (id: string) => void;
};

export const RangeDateGrid = ({
  list,
  headers,
  editable = false,
  deletable = false,
  onEdit,
  onDelete,
}: RangeDateGridProps) => {
  return (
    <GridContainer>
      <GridHeaders>
        {headers?.map(header => (
          <GridHeader key={header}>{header}</GridHeader>
        ))}
      </GridHeaders>
      {list?.map((row: RangeDateType) => (
        <GridRow key={row.id}>
          <GridColumn>{row.startDate}</GridColumn>
          <GridColumn>{row.endDate}</GridColumn>
          <GridColumn>{row.weekDays?.join(",")}</GridColumn>
          {editable && onEdit && (
            <Button
              data-tip="React-tooltip"
              data-for="editLevel"
              size="sm"
              variant="light"
              onClick={() => onEdit(row.id)}>
              <FontAwesomeIcon icon={faPencilAlt} />
            </Button>
          )}
          {deletable && onDelete && (
            <Button
              size="sm"
              variant="light"
              onClick={() => onDelete(row.id)}
              data-tip="React-tooltip"
              data-for="delete">
              <FontAwesomeIcon icon={faTrashAlt} />
            </Button>
          )}
        </GridRow>
      ))}
    </GridContainer>
  );
};
